import { types } from 'mobx-state-tree';

export const optionalMaybeNull = (T) =>
  types.optional(types.maybeNull(T), null);
